import { gql } from '@apollo/client';

export const GET_MACRO_BY_ID_QUERY = gql`
  query getMacroById($filter: MacroArticleFilter) {
    macroArticleFindFirst(filter: $filter) {
      objectId: id
      createdAt
      updatedAt
      couponCodeType
      isActive
      fullSubheading
      category
      text
      articleNumber
      link
      hasImage
      authorId
      author: authorPtr {
        email
      }
      simplrAccountId
      simplrAccountPtr {
        objectId: id
      }
      description
      keywords
      keywords_low
      updaterId
      couponCodeTypeId
      subheading1
      subheading2
      tags
      emailText
      chatText
      expirationDate
      instructions
      deactivationDate
      usageCount
      brand
      dummyButtonActionTag
      macroType
      decisionTreeTags
      chatProductRecsEnabled
      dummyButtonActionTags
      updater: updaterPtr {
        email
      }
    }
  }
`;
